export default __webpack_public_path__ + "static/triangle-5f4a28b0e543f44a37eaef310ac353a9.svg";